import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  icon: IconType;
  className?: string;
  size?: number;
}

const Icon: React.FC<IconProps> = ({ icon: IconComponent, className, size = 20, ...props }) => {
  return React.createElement(IconComponent as React.ComponentType<any>, {
    className,
    size,
    ...props,
  });
};

export default Icon;
